<template>
  <div>
    <div class="row">
      <el-dropdown @command="handleCommand">
        <el-button type="primary">
          Add Quotation
          <i class="el-icon-arrow-down el-icon--right" />
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="primaryLabor">
            Approx. Labor Cost Quotation
          </el-dropdown-item>
          <el-dropdown-item command="secondaryLabor">
            Detailed Labor Cost Quotation
          </el-dropdown-item>
          <el-dropdown-item command="approxProducts">
            Approx. Products Quotation
          </el-dropdown-item>
          <el-dropdown-item command="detailedProducts">
            Request Detail Product Quotation
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <!---------------------- SERVICE REQUEST QUOTATIONS LIST-------------->
    <div class="row service-request-quotations">
      <el-table
        :data="serviceRequestQuotations"
        style="width: 100%"
        row-key="serviceRequestQuotationId"
        @expand-change="getServiceRequestQuotationDetails"
      >
        <el-table-column
          v-if="serviceRequestQuotations.status"
          type="expand"
          min-width="40"
        >
          <template slot-scope="props">
            <div class="quotation-details">
              <div
                v-if="props.row.type === 'Detailed Labor Quotation'"
                class="row"
              >
                <div
                  v-for="(item,
                  index) in serviceRequestQuotationData.productMeta"
                  :key="index"
                  class="product-meta col-md-3"
                >
                  <div class="product-meta-item">
                    <label>Description :</label>
                    <span>{{ item.description }}</span>
                  </div>
                  <div class="product-meta-item">
                    <label>Cost :</label>
                    <span>{{ item.cost }}</span>
                  </div>
                </div>
              </div>
              <div
                v-if="props.row.type === 'Detailed Product Quotation'"
                class="row"
              >
                <div
                  v-for="(item,
                  index) in serviceRequestQuotationData.productMeta"
                  :key="index"
                  class="product-meta col-md-3"
                >
                  <div class="product-meta-item">
                    <label>Product Name :</label>
                    <span>{{ item.name }}</span>
                  </div>
                  <div class="product-meta-item">
                    <label>Quantity :</label>
                    <span>{{ item.quantity }}</span>
                  </div>
                  <div class="product-meta-item">
                    <label>Price :</label>
                    <span>{{ item.price }}</span>
                  </div>
                </div>
              </div>
              <div
                v-if="props.row.type === 'Approx Labor Quotation'"
                class="row"
              >
                <div class="product-meta">
                  <div class="product-meta-item">
                    <label>Description :</label>
                    <span>{{ props.row.description }}</span>
                  </div>
                  <div class="product-meta-item">
                    <label>Labor Cost :</label>
                    <span>{{ props.row.total }}</span>
                  </div>
                </div>
              </div>
              <div
                v-if="props.row.type === 'Approx Product Quotation'"
                class="row"
              >
                <div class="product-meta">
                  <div class="product-meta-item">
                    <label>Description :</label>
                    <span>{{ props.row.description }}</span>
                  </div>
                  <div class="product-meta-item">
                    <label>Cost :</label>
                    <span>{{ props.row.total }}</span>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column type="index" label="#" min-width="30" />
        <el-table-column label="Date" min-width="30">
          <template slot-scope="scope">{{
            scope.row.updatedAt | dateFormat
          }}</template>
        </el-table-column>
        <el-table-column
          label="Quotation Number"
          prop="quotationNumber"
          min-width="40"
        />
        <el-table-column label="Type" prop="type" min-width="50" />
        <el-table-column label="Total" prop="total" min-width="32" />
        <el-table-column label="Status" min-width="43">
          <template slot-scope="scope">
            <span v-if="scope.row.status">
              <el-tag
                v-if="scope.row.status.code === 'pending'"
                class="pending-status"
                effect="dark"
              >
                {{ scope.row.status.label }}
              </el-tag>
              <el-tag
                v-else-if="scope.row.status.code === 'dispatched'"
                class="dispatch-status"
                effect="dark"
              >
                {{ scope.row.status.label }}
              </el-tag>
              <el-tag
                v-else-if="scope.row.status.code === 'accepted'"
                type="success"
                effect="dark"
              >
                {{ scope.row.status.label }}
              </el-tag>
              <el-tag
                v-else-if="scope.row.status.code === 'declined'"
                class="declined-status"
                effect="dark"
              >
                {{ scope.row.status.label }}
              </el-tag>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="Actions" min-width="40">
          <template slot-scope="scope">
            <base-button
              v-if="
                (scope.row.status.code === 'dispatched' &&
                  scope.row.type === 'Detailed Product Quotation') ||
                  (scope.row.status.code === 'pending' &&
                    scope.row.type !== 'Detailed Product Quotation')
              "
              size="sm"
              @click="updateQuotation(scope.row)"
              >Accept</base-button
            >
            <span v-else>No Actions</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!----------------------APPROX LABOR DIALOG-------------->
    <el-dialog :visible.sync="showLaborDialog" title="Approx. Labor Quotation">
      <div class="row">
        <div class="col-md-6">
          <base-input
            v-model="serviceRequestQuotation.total"
            type="number"
            label="Labor Amount"
          />
        </div>
        <div class="col-md-6">
          <base-input label="Description">
            <textarea
              v-model="serviceRequestQuotation.description"
              tabindex="7"
              rows="2"
              class="form-control"
            />
          </base-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showLaborDialog = false">Cancel</el-button>
        <el-button type="primary" @click="saveQuotation('labor-cost')">
          Confirm
        </el-button>
      </span>
    </el-dialog>

    <!----------------------DETAILED LABOR DIALOG-------------->
    <el-dialog
      :visible.sync="showDetailedLaborCost"
      title="Detailed Labor Quotation"
    >
      <div class="row">
        <div class="col-md-6">
          <base-input label="Select Labor">
            <el-select
              v-model="selectedLabor"
              clearable
              filterable
              style="width: 100%"
              value-key="laborCostId"
              @change="addDetailedLabor"
            >
              <el-option
                v-for="(item, index) in laborCosts"
                :key="index"
                :value="item"
                :label="`${item.description} (${item.cost})`"
              />
            </el-select>
          </base-input>
        </div>
      </div>

      <div>
        <el-table :data="detailedLaborCosts">
          <el-table-column label="Description" prop="description" />
          <!-- el="Cost" prop="cost"></el-table-column> -->
          <el-table-column label="Operations">
            <template slot-scope="scope">
              <el-button
                style="margin-bottom: 20px"
                size="mini"
                type="danger"
                @click="handleDetailedLaborCostDelete(scope.$index)"
              >
                <i class="el-icon-delete" />
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showDetailedLaborCost = false">Cancel</el-button>
        <el-button type="primary" @click="saveQuotation('detail-labor-cost')">
          Confirm
        </el-button>
      </span>
    </el-dialog>

    <!---------------------- APPROX. PRODUCTS DIALOG-------------->
    <el-dialog
      :visible.sync="showApproxProducts"
      title="Approx. Products Quotation"
    >
      <div class="row">
        <div class="col-md-6">
          <base-input
            v-model="serviceRequestQuotation.total"
            label="Total Amount"
          />
        </div>
        <div class="col-md-6">
          <base-input label="Description">
            <textarea
              v-model="serviceRequestQuotation.description"
              tabindex="7"
              rows="2"
              class="form-control"
            />
          </base-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showApproxProducts = false">Cancel</el-button>
        <el-button type="primary" @click="saveQuotation('approx-product')">
          Confirm
        </el-button>
      </span>
    </el-dialog>

    <!---------------------- DETAILED PRODUCTS DIALOG-------------->
    <el-dialog
      :visible.sync="showDetailedProducts"
      title="Detailed Products Quotation"
    >
      <base-button
        size="sm"
        type="primary"
        style="float: right"
        @click="handleDetailedProductAdd()"
      >
        Add New
      </base-button>
      <el-table :data="detailedProductData" style="padding-top: 10px">
        <el-table-column label="Product Name">
          <template slot-scope="scope">
            <base-input>
              <el-autocomplete
                v-uppercase
                ref="searchProduct"
                v-model="scope.row.name"
                :fetch-suggestions="suggestProducts"
                :trigger-on-focus="false"
                class="product-search"
                placeholder="Type..."
                tabindex="4"
                style="width: 100%"
                @select="val => handleProductSelect(val, scope.row)"
              >
                <template slot-scope="{ item }">{{ item.name }}</template>
              </el-autocomplete>
            </base-input>
          </template>
        </el-table-column>
        <el-table-column label="Qty." min-width="40">
          <template slot-scope="scope">
            <base-input v-model="scope.row.quantity" />
          </template>
        </el-table-column>
        <el-table-column label="Actions" min-width="40">
          <template slot-scope="scope">
            <el-button
              style="margin-bottom: 20px"
              size="mini"
              type="danger"
              @click="handleDetailedProductDelete(scope.$index)"
            >
              <i class="el-icon-delete" />
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showDetailedProducts = false">Cancel</el-button>
        <el-button type="primary" @click="saveQuotation('detail-product')">
          Request Quotation
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import dateFns from "date-fns";
import {
  Dropdown,
  DropdownMenu,
  Button,
  DropdownItem,
  Table,
  TableColumn,
  Dialog,
  Autocomplete,
  Select,
  Option,
  Icon,
  Tag
} from "element-ui";
export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  filters: {
    dateFormat(value) {
      return dateFns.format(new Date(value), "DD MMM YYYY");
    }
  },
  components: {
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [DropdownItem.name]: DropdownItem,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dialog.name]: Dialog,
    [Autocomplete.name]: Autocomplete,
    [Select.name]: Select,
    [Option.name]: Option,
    [Icon.name]: Icon,
    [Tag.name]: Tag
  },
  data() {
    return {
      searchKeyword: "",
      showLaborDialog: false,
      showApproxProducts: false,
      showDetailedProducts: false,
      showDetailedLaborCost: false,
      primaryLabor: "",
      secondaryLabor: "",
      selectedLabor: {},
      serviceRequestQuotationData: {}
      // selectedProductName: ''
    };
  },

  computed: {
    ...mapState("serviceRequestQuotation", [
      "serviceRequestQuotation",
      "detailedProductData",
      "detailedLaborCosts",
      "serviceRequestQuotations"
    ]),
    ...mapState("laborCost", ["laborCosts"]),
    ...mapState("serviceRequestChalan", ["serviceRequestChalansList"]),
    ...mapState("serviceRequest", ["serviceRequest"]),

    ...mapGetters({
      statusList: "status/getStatusList"
    })
  },

  mounted() {
    this.fetchServiceRequest(this.$route.params.id);
    this.getServiceRequestQuotations(this.$route.params.id);
    this.getServiceRequestChalans(this.$route.params.id);
    this.getLaborCosts();
    this.getStatuses();
  },
  methods: {
    ...mapActions({
      saveServiceRequestQuotation:
        "serviceRequestQuotation/saveServiceRequestQuotation",
      getServiceRequestQuotations:
        "serviceRequestQuotation/getServiceRequestQuotations",
      getProducts: "product/getProducts",
      getLaborCosts: "laborCost/getLaborCosts",
      fetchServiceRequestQuotationDetails:
        "serviceRequestQuotation/getServiceRequestQuotationDetails",
      getStatuses: "status/getStatusList",
      updateServiceRequestQuotation:
        "serviceRequestQuotation/updateServiceRequestQuotation",
      fetchServiceRequest: "serviceRequest/fetchServiceRequest",
      getServiceRequestChalans: "serviceRequestChalan/getServiceRequestChalans"
    }),
    ...mapMutations({
      resetQuotation: "serviceRequestQuotation/resetQuotation",
      resetProductData: "serviceRequestQuotation/resetProductData",
      resetDetailedLaborCosts: "serviceRequestQuotation/resetDetailedLaborCosts"
    }),
    removeLaborCost(index) {
      if (this.serviceRequestQuotations.length > 1) {
        this.serviceRequestQuotations.splice(index, 1);
      } else {
        this.$notify({
          message: "Can not Remove!",
          type: "danger",
          title: "Error"
        });
      }
    },
    addMoreLaborCost() {
      this.serviceRequestQuotations.push({
        description: "",
        total: null,
        isLaborCost: true
      });
    },

    handleCommand(command) {
      if (command === "primaryLabor") {
        if (
          this.serviceRequestChalansList.length > 0 ||
          this.serviceRequest.externalGoodsMeta.length > 0
        ) {
          this.$notify({
            message:
              "Sorry, you cannot add quotation after adding chalan/external goods!",
            type: "danger",
            title: "Error"
          });
        } else if (
          this.serviceRequest.status.code === "visited" ||
          this.serviceRequest.status.code === "quotation_pending" ||
          this.serviceRequest.status.code === "quotation_completed"
        ) {
          this.resetQuotation();
          this.showLaborDialog = true;
        } else {
          this.$notify({
            message: "Sorry, you cannot add quotation at this step!",
            type: "danger",
            title: "Error"
          });
        }
      } else if (command === "approxProducts") {
        if (
          this.serviceRequestChalansList.length > 0 ||
          this.serviceRequest.externalGoodsMeta.length > 0
        ) {
          this.$notify({
            message:
              "Sorry, you cannot add quotation after adding chalan/external goods!",
            type: "danger",
            title: "Error"
          });
        } else if (
          this.serviceRequest.status.code === "visited" ||
          this.serviceRequest.status.code === "quotation_pending" ||
          this.serviceRequest.status.code === "quotation_completed"
        ) {
          this.resetQuotation();
          this.showApproxProducts = true;
        } else {
          this.$notify({
            message: "Sorry, you cannot add quotation at this step!",
            type: "danger",
            title: "Error"
          });
        }
      } else if (command === "detailedProducts") {
        if (
          this.serviceRequestChalansList.length > 0 ||
          this.serviceRequest.externalGoodsMeta.length > 0
        ) {
          this.$notify({
            message:
              "Sorry, you cannot add quotation after adding chalan/external goods!",
            type: "danger",
            title: "Error"
          });
        } else if (
          this.serviceRequest.status.code === "visited" ||
          this.serviceRequest.status.code === "quotation_pending" ||
          this.serviceRequest.status.code === "quotation_completed"
        ) {
          this.resetProductData();
          this.resetQuotation();
          this.showDetailedProducts = true;
        } else {
          this.$notify({
            message: "Sorry, you cannot add quotation at this step!",
            type: "danger",
            title: "Error"
          });
        }
      } else if (command === "secondaryLabor") {
        if (
          this.serviceRequestChalansList.length > 0 ||
          this.serviceRequest.externalGoodsMeta.length > 0
        ) {
          this.$notify({
            message:
              "Sorry, you cannot add quotation after adding chalan/external goods!",
            type: "danger",
            title: "Error"
          });
        } else if (
          this.serviceRequest.status.code === "visited" ||
          this.serviceRequest.status.code === "quotation_pending" ||
          this.serviceRequest.status.code === "quotation_completed"
        ) {
          (this.selectedLabor = {}), this.resetDetailedLaborCosts();
          this.resetQuotation();
          this.showDetailedLaborCost = true;
        } else {
          this.$notify({
            message: "Sorry, you cannot add quotation at this step!",
            type: "danger",
            title: "Error"
          });
        }
      }
    },
    handleDetailedProductAdd() {
      this.detailedProductData.push({
        productId: "",
        name: "",
        quantity: null,
        taxRate: null
      });
    },
    handleDetailedProductDelete(index) {
      this.detailedProductData.splice(index, 1);
    },
    async suggestProducts(query, cb) {
      const result = await this.getProducts({ searchKeyword: query });
      cb(result.rows);
    },
    saveQuotation(type) {
      this.saveServiceRequestQuotation({
        type,
        serviceRequestId: this.$route.params.id
      })
        .then(async () => {
          await this.getServiceRequestQuotations(this.$route.params.id);
          await this.fetchServiceRequest(this.$route.params.id);
          this.showApproxProducts = false;
          this.showLaborDialog = false;
          this.showDetailedProducts = false;
          this.showDetailedLaborCost = false;
          this.$notify({
            message: "Quotation Added Succesfully....!",
            type: "success",
            title: "Success"
          });
        })
        .catch(() => {
          this.$notify({
            message: "Try Again!",
            type: "danger",
            title: "Failure"
          });
        });
    },
    handleProductSelect(selectedProduct, row) {
      row.productId = selectedProduct.productId;
      (row.name = selectedProduct.name),
        (row.taxRate = selectedProduct.tax.rate);
      row.quantity = 1;
    },
    addDetailedLabor(item) {
      this.detailedLaborCosts.push(item);
    },
    handleDetailedLaborCostDelete(index) {
      this.detailedLaborCosts.splice(index, 1);
    },
    getServiceRequestQuotationDetails(row) {
      this.fetchServiceRequestQuotationDetails(
        row.serviceRequestQuotationId
      ).then(res => {
        row.details = res.data;
        this.serviceRequestQuotationData = res.data;
      });
    },
    updateQuotation(data) {
      const newStatus = this.statusList.find(i => i.code === "accepted");
      this.updateServiceRequestQuotation({
        statusId: newStatus.statusId,
        serviceRequestQuotationId: data.serviceRequestQuotationId,
        serviceRequestId: this.$route.params.id
      }).then(res => {
        this.getServiceRequestQuotations(this.$route.params.id);
        this.$notify({
          message: "Quotation Updated Succesfully!",
          type: "success",
          title: "Success"
        });
      });
    }
  }
};
</script>

<style>
.detail-product-remove-item {
  margin-left: 60px;
  margin-top: -30px;
  font-size: 25px;
  cursor: pointer;
}

.detailed-labor-cost-remove-item {
  margin-left: 26px;
  margin-top: 0px;
  font-size: 25px;
  cursor: pointer;
}
.service-request-quotations {
  margin-top: 20px;
  margin-bottom: 90px;
}
.product-meta {
  display: flex;
  flex-direction: column;
  margin-left: 30px;
  margin-right: 30px;
}
.product-meta-item {
  display: flex;
}
.product-meta-item label {
  font-weight: 600;
  font-size: 13px;
  margin-right: 4px;
}
.dispatch-button {
  margin-left: 15px;
  margin-top: 20px;
}
.pending-status {
  background-color: #e72626;
  border-color: #e72626;
  color: #fff;
}
.dispatch-status {
  background-color: #f57316eb;
  border-color: #f57316eb;
  color: #fff;
}
.declined-status {
  background-color: #b0ccb3;
  border-color: #b0ccb3;
  color: #fff;
}
</style>
